import React, { useEffect, useState } from 'react';
import classes from "./SubscribePage.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import Cookies from "js-cookie";
import {toast} from "react-toastify";
import { SendOtpAPI } from '../Http/http';

const SubscribePage = () => {
    const [msisdn, setMsisdn] = useState("");
    const [subscribeLoading, setSubscribeLoading] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);

    useEffect(() => {
        if (Cookies.get("msisdn")) {
            navigate("/home");
        }
    }, []);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const navigate = useNavigate();

        const handleFormSubmission = async (e) => {
        e.preventDefault();

        try {
            if (msisdn?.trim().length == 0) {
                return;
            }
            setSubscribeLoading(true);

            let msisdnWithCountryCode = msisdn?.toString().trim().replace(/\D/g, '');

            if (msisdnWithCountryCode.startsWith('0')) {
                msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
            }

            if (!msisdnWithCountryCode.startsWith('94')) {
                msisdnWithCountryCode = '94' + msisdnWithCountryCode;
            }

            const response = await SendOtpAPI(msisdnWithCountryCode);
            console.log(response, 'response');
            setSubscribeLoading(false);
            navigate("/otp", {
                state: {
                    msisdn: msisdnWithCountryCode,
                    referenceNo: response?.data?.data?.referenceNo,
                    extRef: extRef
                }
            })

        } catch (error) {
            setSubscribeLoading(false);
            toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
        }
    }

    return (
        <main className={classes.main}>
            <div className={classes.container}>
                <h1 className={classes.portalDescription}>Games Dal</h1>

                <div className={classes.landingPageBanner}>
                    <img src="assets/images/banner.gif" alt="Banner" className={classes.banner} />
                </div>

                <div className={classes.actions_box_container}>
                    <div className={classes.actions_box}>
                        <button type="button" className={classes.action_box}
                           onClick={() => navigate(`/login?ext_ref=${extRef}`)}
                        >
                            Login
                        </button>
                        <button type="button" className={`${classes.action_box} ${classes.active}`}
                        >
                            Subscribe
                        </button>
                    </div>
                </div>

                <input type='number' placeholder='Enter your Number' value={msisdn} onChange={(e) => setMsisdn(e.target.value)}
                    className={classes.input}
                />

                <div className={classes.packs}>
                    <button type='button' className={`${classes.pack_box} ${classes.shade_blue}`}
                    >
                        <span className={`${classes.pack_header} ${classes.shade_blue}`}>Prepaid subscription price point</span>
                        <p className={`${classes.pack_price_point} ${classes.active}`}>
                            10 LKR{" "}/{" "} Day
                        </p>
                    </button>
                      <button type='button' className={`${classes.pack_box} ${classes.shade_green}`}
                    >
                        <span className={`${classes.pack_header} ${classes.shade_green}`}>Postpaid subscription price point</span>
                        <p className={`${classes.pack_price_point} ${classes.active}`}>
                            300 LKR{" "}/{" "} Month
                        </p>
                    </button>
                </div>

                <button className={classes.subscribeBtn} id="subscribe_btn" 
                onClick={handleFormSubmission}
                    disabled={subscribeLoading}
                >
                    {subscribeLoading ? "Subscribing..." : (
                        <>
                            Subscribe NOW <img src="/assets/images/lock.png" alt="lock" className={classes.lockImg} />
                        </>

                    )}
                </button>

                {/* <div className={classes.termsSection}>
                    <h1 className={classes.termsHeading}>Terms & Conditions</h1>
                    <ul className={classes.termsList}>
                        <li>The service cost is KSH 15/day.</li>
                        <li>Your Subscription will be renewed at KSH 15/day, automatically until you unsubscribe.</li>
                        <li>You can unsubscribe from the service anytime, by dialling USSD code *xxx# or deactivating from the portal.</li>
                        <li>All data-enabled features & Smartphone users can enjoy full service.</li>
                        <li>Customer can access the content at any time during the subscription validity period.</li>
                    </ul>
                </div> */}

            </div >
        </main >
    )
}

export default SubscribePage